/*
 * form Actions
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 12-Jan-2023
 */

import { createRequestTypes, createAction, MakeRequest } from './index';

export const actionTypes = {
  // @generator action:type
  ...createRequestTypes('@@form', 'GET_COUNTRIES'),
  // @generator action:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name getCountries
 * @return {object} - The action object
 */
export const getCountries = new MakeRequest('form', 'get_countries');

// @generator action:request
// @generator action
